/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle Batch Export - Select Folder" |
*
* @param {Batch_Subtitle_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_select_folder_title = /** @type {((inputs?: Batch_Subtitle_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lot de sous-titres - Sélectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Stapelexport – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione batch sottotitoli - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт субтитров - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación por lotes de subtítulos: Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕批量导出 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕一括エクスポート - フォルダの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक बैच निर्यात - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote de legendas - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Subtitle Batch Export - Select Folder")
});